@if (state() === "loading") {
  <app-loading />
}

@if (state() === "error") {
  <app-error-data
    [title]="isArabic() ? 'حدث بعض الخطأ' : 'Something went wrong'"
    [showRetry]="true"
    (retry)="getOrders.emit()" />
}

@if (state() === "success") {
  <app-tables
    [headerItems]="tableHeaderData()"
    [rows]="rows()"
    [scopeResolver]="orderScopeResolver"
    (toggleDropdown)="toggleDropdown($event)"
    [currentActions]="currentActions()"
    (actionTrigger)="handleAction($any($event))"
    [isFiltersApplied]="isFiltersApplied()"
    [emptyFilterTitle]="isArabic() ? 'لا توجد طلبات تطابق معايير البحث.' : 'No orders match your criteria.'"
    [emptyContentTitle]="isArabic() ? 'لا توجد طلبات' : 'No Orders Found'"
    [emptyContentDescription]="isArabic() ? 'لا توجد طلبات في النظام.' : 'No orders found in the system.'" />

  <app-pagination
    [itemsPerPage]="itemsPerPage()"
    [currentPage]="currentPage()"
    [getPageNumbers]="pageNumbers()"
    [totalPages]="totalPages()"
    [startItem]="startItem()"
    [endItem]="endItem()"
    [totalItems]="totalItems()"
    (previousPage)="onPreviousPage()"
    (nextPage)="onNextPage()"
    (goToPage)="onGoToPage($event)"
    (changePageNumber)="onChangePageNumber($event)"
    (pageSizeChange)="onPageSizeChange()" />
}

@if (printPopup()) {
  <app-order-action-popup
    #printPopup
    (submit)="onPrint(printPopup.comment())"
    [title]="isArabic() ? 'طباعة' : 'print'"
    (closePopup)="onCancelPrintPopup()"
    [loading]="printing()"
    [err]="errPrintAction()"
    [submitBtnContent]="isArabic() ? 'طباعة ' : 'Print'" />
}

@if (successNotification()) {
  <app-successful-notification
    type="success"
    [title]="isArabic() ? 'تمت طباعة الطلب بنجاح.' : 'Order printed successfully.'" />
}

@if (isDeliverPopup()) {
  <app-order-action-popup
    #deliverPopup
    type="deliver"
    [loading]="delivering()"
    [expectedAmount]="expectedAmount()"
    [(amountCollected)]="deliverAmountCollected"
    [label]="isArabic() ? 'تعليق' : 'Comment'"
    (submit)="onDeliverOrder(deliverPopup.comment(), deliverPopup.amountCollected())"
    [title]="isArabic() ? 'تسليم الطلب' : 'Deliver Order'"
    (closePopup)="onCloseDeliver()"
    [err]="errDeliver()"
    [description]="isArabic() ? 'هل أنت متأكد من تسليم الطلب؟' : 'Are you sure you want to confirm deliver this order?'"
    [submitBtnContent]="isArabic() ? 'تأكيد' : 'Confirm'" />
}

@if (successDeliverNotification()) {
  <app-successful-notification
    type="success"
    [title]="isArabic() ? 'تم تسليم الطلب بنجاح.' : 'Order delivered successfully.'" />
}
